export default __webpack_public_path__ + "static/media/warning.b5d56482.png";